<template>
  <router-view :key="$route.fullPath" />
</template>

<script>
export default {
  name: "LayoutNone"
}
</script>

<style scoped>

</style>